import { createSlice } from "@reduxjs/toolkit";
import appointmentDetailsbyUID from "@custom/rtk-apis/appointment/getAppointmentbyUID";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const appointmentDetailbyUIDSlice = createSlice({
  name: "appointmentDetailbyUIDSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(appointmentDetailsbyUID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(appointmentDetailsbyUID.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(appointmentDetailsbyUID.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default appointmentDetailbyUIDSlice.reducer;
